<template>
<v-layout class="fill-height">
  <v-container
    id="contentDashboard" fluid
    class="fill-height"
  >
    <v-layout>
      <v-row
        align="start"
        justify="start"
      >
        <v-col cols="12" md="12" class="pt-1">
          <v-snackbar
            v-model="snackbar"
            :color="color"
            right
            top
            multi-line
            app
          >
            {{snackbarText}}
            <v-btn
              text
              dark
              @click="snackbar = false"
            >
              Fermer
            </v-btn>
          </v-snackbar>
          <v-dialog v-model="dialog" persistent max-width="600px">
            <v-card>
                <v-card-title>
                <span class="headline">Ajouter Prestation</span>
                </v-card-title>
                <v-card-text>
                <v-container>
                    <v-row>
                    <v-col cols="12" sm="12" md="12">
                        <v-text-field label="Code Prestation*" disabled v-model="prestationTmp.code_prestation" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-select
                          :items="types"
                          v-model="prestationTmp.type_prestation"
                          label="Type"
                        ></v-select>
                    </v-col>
                    <v-col cols="12" sm="6" md="6">
                        <v-select
                          :items="impoexpo"
                          v-model="prestationTmp.impoexpo"
                          label="Import/Export"
                        ></v-select>
                    </v-col>
                    <v-col cols="12">
                        <v-text-field label="Description" v-model="prestationTmp.description" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field label="TVA" v-model="prestationTmp.tva" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field label="Montant" v-model="prestationTmp.montant" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="12">
                        <v-select label="Devise" v-model="prestationTmp.devise" :items="['TND', 'USD', 'EUR']" required></v-select>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field label="Cour" v-model="prestationTmp.cour" required></v-text-field>
                    </v-col>
                    <v-col cols="12" sm="6">
                        <v-text-field label="Montant Devise (sauf TND)" v-model="prestationTmp.montantDevise" required></v-text-field>
                    </v-col>
                    </v-row>
                </v-container>
                <small>*toutes les cases indiquées avec étoiles sont obligatoires</small>
                </v-card-text>
                <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="blue darken-1" text @click="dialog = false">Fermer</v-btn>
                <v-btn color="blue darken-1" text @click="addPrestation">Ajouter</v-btn>
                </v-card-actions>
            </v-card>
            </v-dialog>
          <v-expansion-panels v-model="panel" :readonly="readonly" accordion multiple>
              <v-expansion-panel>
                  <v-expansion-panel-header><span class="expan-title"> Liste des Préstations</span> </v-expansion-panel-header>
                  <v-expansion-panel-content>
                      <div class="ml-2 text-left"><v-btn @click="openDialog" depressed small style="background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); box-shadow:0 0 20px rgba(0,0,0,0.2); color: white; border-radius:25px;">Nouveau</v-btn></div>
                      <v-data-table
                            :headers="headers"
                            :items="prestations"
                            :items-per-page="5"
                            class="elevation-0"
                        >
                            <template v-slot:[`item.montant`]="{ item }">
                                {{item.montant.toFixed(3)}} TND
                            </template>
                            <template v-slot:[`item.tva`]="{ item }">
                                {{item.tva}}%
                            </template>
                            <template v-slot:[`item.actions`]="item">
                                <v-btn :ripple="false" @click="openItem(item.item)" icon>
                                    <v-icon
                                        small
                                        class="mr-2"
                                    >
                                        mdi-eye
                                    </v-icon>
                                </v-btn>
                                <v-icon
                                    small
                                    class="mr-2"
                                    @click="editItem(item.item)"
                                >
                                    mdi-pencil
                                </v-icon>
                                <v-icon
                                    small
                                    :disabled="!permissions.includes('delete_database')"
                                    @click="deleteItem(item.item)"
                                >
                                    mdi-delete
                                </v-icon>
                            </template>
                        </v-data-table>

                  </v-expansion-panel-content>
                </v-expansion-panel>
            </v-expansion-panels>
        </v-col>
        <v-col md="12" style="height:fit-content;">
            <v-card
            width="98%"
            v-if="currentPrestation !== null"
            style="margin: 0 auto; background: none;"
            class="elevation-0"
            >
                <v-row>
                
                <v-col md="4"  v-if="edit === false">
                    <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="headline mb-1">Code Prestation</v-list-item-title>
                        <v-list-item-subtitle>{{currentPrestation.code_prestation}}</v-list-item-subtitle>
                    </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col md="4" v-else>
                  <v-text-field label="Code Prestation" outlined hide-details disabled v-model="currentPrestation.code_prestation" required></v-text-field>  
                </v-col>
                <v-col md="4" v-if="edit === false">
                    <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="headline mb-1">Description Prestation</v-list-item-title>
                        <v-list-item-subtitle>{{currentPrestation.description}}</v-list-item-subtitle>
                    </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col md="4" v-else>
                  <v-text-field label="Description Prestation" outlined hide-details v-model="currentPrestation.description" required></v-text-field>  
                </v-col>
                <v-col md="4" v-if="edit === false">
                    <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="headline mb-1">Type</v-list-item-title>
                        <v-list-item-subtitle>{{currentPrestation.type_prestation}}</v-list-item-subtitle>
                    </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col md="4" v-else>
                  <v-select
                    :items="types"
                    v-model="currentPrestation.type_prestation"
                    label="Type"
                    outlined
                  ></v-select>
                </v-col>
                <v-col md="4" v-if="edit === false">
                    <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="headline mb-1">Import/Export</v-list-item-title>
                        <v-list-item-subtitle>{{currentPrestation.impoexpo}}</v-list-item-subtitle>
                    </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col md="4" v-else>
                  <v-select
                    :items="impoexpo"
                    v-model="currentPrestation.impoexpo"
                    label="Import/Export"
                    outlined
                  ></v-select>
                </v-col>
                <v-col md="4" v-if="edit === false">
                    <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="headline mb-1">Devise</v-list-item-title>
                        <v-list-item-subtitle>{{currentPrestation.devise}}</v-list-item-subtitle>
                    </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col md="4" v-else>
                  <v-select label="Devise" outlined v-model="currentPrestation.devise" :items="['TND', 'USD', 'EUR']" required></v-select>
                </v-col>
                <v-col md="4" v-if="edit === false">
                    <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="headline mb-1">Montant (TND)</v-list-item-title>
                        <v-list-item-subtitle>{{Number(currentPrestation.montant).toFixed(3)}} TND</v-list-item-subtitle>
                    </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col md="4" v-else>
                  <v-text-field label="Montant (TND)" outlined hide-details v-model="currentPrestation.montant" required></v-text-field>  
                </v-col>
                <v-col md="4" v-if="edit === false">
                    <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="headline mb-1">Cour</v-list-item-title>
                        <v-list-item-subtitle>{{Number(currentPrestation.cour).toFixed(3)}}</v-list-item-subtitle>
                    </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col md="4" v-else>
                  <v-text-field label="Cour" outlined hide-details v-model="currentPrestation.cour" required></v-text-field>  
                </v-col>
                <v-col md="4" v-if="edit === false">
                    <v-list-item two-line>
                    <v-list-item-content>
                        <v-list-item-title class="headline mb-1">Montant en Devise</v-list-item-title>
                        <v-list-item-subtitle>{{Number(currentPrestation.montantDevise).toFixed(3)}}</v-list-item-subtitle>
                    </v-list-item-content>
                    </v-list-item>
                </v-col>
                <v-col md="4" v-else>
                  <v-text-field label="Montant en Devise" outlined hide-details v-model="currentPrestation.montantDevise" required></v-text-field>  
                </v-col>
                </v-row>
                
                <v-card-actions>
                  <v-spacer></v-spacer>
                <v-btn style="background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); box-shadow:0 0 20px rgba(0,0,0,0.2); color: white;" v-if="!edit" @click="edit = true">Editer</v-btn>
                <v-btn style="background: linear-gradient(90deg, rgba(13,74,186,1) 0%, rgba(9,155,223,1) 100%); box-shadow:0 0 20px rgba(0,0,0,0.2); color: white;" v-if="edit" @click="editPrestation">Editer</v-btn>
                <v-btn color="error" :disabled="!permissions.includes('delete_database')" @click="deleteItem(currentPrestation)">Supprimer</v-btn>
                </v-card-actions>
            </v-card>
        </v-col>
      </v-row>
    </v-layout>
  </v-container>
</v-layout>
</template>
<script>

export default {
  name: 'manage-prestations',
  props: ['permissions'],
  data: () => ({
    drawer: true,
    panel: [0],
    currentManagement: {title: 'Tous'},
    business: 5,
    filterSelectbox: ['Tous','Import', 'Export'],
    mini: false,
    readonly: true,
    edit: false,
    currentPrestation: null,
    search: '',
    expanded: [],
    drawerClass: '',
    dialog: false,
    row: 'import',
    dialog: false,
    types: [
      {value: 'Préstation', text:'Préstation'},
      {value: 'Fret', text:'Fret'}
    ],
    impoexpo: [
      {value: 'Import', text:'Import'},
      {value: 'Export', text:'Export'}
    ],
    headers: [
        {
        text: 'Code',
        align: 'start',
        sortable: false,
        value: 'code_prestation',
        },
        { text: 'Description', value: 'description' },
        { text: 'Type', value: 'type_prestation' },
        { text: 'TVA', value: 'tva' },
        { text: 'Montant', value: 'montant' },
        { text: 'Devise', value: 'devise' },
        { text: 'Actions', value: 'actions', sortable: false },
    ],
    prestations: [],
    prestationTmp: {
      type_prestation: 'Préstation',
      impoexpo: 'Import',
      montant: null,
      montantDevise: null,
      cour: null
    },
    snackbar: false,
    snackbarText: '',
    color: "success"
  }),
  mounted () {
    this.axios
      .get('/prestation/listing')
      .then(response => (this.prestations = response.data))
    },
  methods: {
      openItem(item){
          this.panel = [1];
          this.readonly = false;
          this.currentPrestation = item;
      },
      setPrestationNumber(){
        if(this.prestations.length > 0){
          var nextCode = this.prestations.reduce((max, p) => p.code_prestation > max ? p.code_prestation : max, this.prestations[0].code_prestation)
          nextCode = Number(nextCode) + 1
          if(nextCode.toString().length === 1){
            nextCode = '0'+nextCode
          }
        }else{
          nextCode = "01"
        }
        this.prestationTmp.code_prestation = nextCode
      },
      openDialog(){
          this.setPrestationNumber()
          this.dialog = true
      },
      editItem(item){
        this.edit = true
        this.panel = [1];
        this.readonly = false;
        this.currentPrestation = Object.assign({}, item);
      },
      reloadData(){
         this.axios
          .get('/prestation/listing')
          .then(response => (this.prestations = response.data))
      },
      addPrestation(){
        if(Number(this.prestationTmp.montant) !== 0 )
          this.prestationTmp.montant = Number(this.prestationTmp.montant.replace(",", "."))
        if(Number(this.prestationTmp.cour) !== 0)
          this.prestationTmp.cour = Number(this.prestationTmp.cour.replace(",", "."))
        if(Number(this.prestationTmp.montantDevise) !== 0 )
          this.prestationTmp.montantDevise = Number(this.prestationTmp.montantDevise.replace(",", "."))
        this.axios.post('/prestation/create', this.prestationTmp, {
          }).then((res) => {
            if(res.data === 'error'){
              this.color = "error"
              this.snackbarText = "Essayez de remplir tous les champs obligatoires."
              this.snackbar = true
            }else{
              this.color = "success"
              this.snackbarText = "La préstation a été ajoutée avec succès."
              this.snackbar = true
              this.reloadData()
              this.dialog = false
              this.prestationTmp = {
                type_prestation: 'Préstation',
                impoexpo: 'Import',
                montant: null,
                montantDevise: null,
                cour: null
                }
            }
            
          }).catch(e => {
            this.color = "error"
            this.snackbar = true
            this.snackbarText = "Un erreur est survenu, essayez plus tard."
            console.log(e)
          })
      },
      editPrestation(){
        this.axios.put('/prestation/edit', this.currentPrestation, {
        }).then((res) => {
            if(res.data === 'error'){
            this.color = "error"
            this.snackbarText = "Essayez de remplir tous les champs obligatoires."
            this.snackbar = true
            }else{
            this.color = "success"
            this.snackbarText = "La préstation a été modifiée avec succès."
            this.snackbar = true
            this.edit = false
            this.reloadData()
            }
        }).catch(e => {
            this.color = "error"
            this.snackbar = true
            this.snackbarText = "Un erreur est survenu, essayez plus tard."
            console.log(e)
        })
      },
      deleteItem (item) {
        const index = this.prestations.indexOf(item)
        console.log(item)
        this.axios.delete('/prestation/delete/' + item.id)
        .then(response => {
          if(confirm('Êtes-vous sûr de bien vouloir supprimer cet élément?') && this.prestations.splice(index, 1)){
            this.color = "success"
            this.snackbarText = "La préstation a été supprimée avec succès."
            this.snackbar = true
            this.currentPrestation = null
            this.panel = [0]
          }
          
        });
      },
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
  .v-expansion-panel:before {
    box-shadow: 0 0 0 transparent !important;
  }
  .expan-title{
    color: #000;
    font-weight: 700;
    font-size: 18px;
  }
  .filter-selectbox{
    margin-left: 16px;
    width: 63%;
  }
  h1, h2 {
    font-weight: normal;
  }
  .no-width {
    width: 0px !important;
    min-width: 0px !important;
    padding:25px 0px !important;
  }
  ul {
    list-style-type: none;
    padding: 0;
  }
  li {
    display: inline-block;
    margin: 0 10px;
  }
  a {
    color: #42b983;
  }
  .table-content {
    margin: 0 auto;
    margin-top: 25px;
    width: 96%;
    .v-input__control{
      min-width: 210px;
    }
  }
  .second-sidebar {
    box-shadow: 0 0 35px rgba(0,0,0,0.05);
    min-width:360px;
    padding:25px;
  }
  .add-btn {
    background: #207ddd;
    box-shadow: 5px 10px 20px #207ddd40;
    font-size: 12px;
  }
  .toggle-second-sidebar {
    float: left;
    width: 48px;
    height: 48px;
    top: 89px;
    transform: translateX(-24px);
    font-size:12px;
    background: white;
    border: 1px solid rgba(0,0,0,0.1);
    .toggle-icon {
      margin-left:15px;
    }
  }
  .main-toolbar {
    background: transparent !important;
    .back-dashboard {
      font-size: 12px;
      color: #9ca8b4;
      letter-spacing: 0.02em;
      text-transform: none;
      font-weight: 700;
      .v-icon {
        font-size: 14px;
      }
    }
    .right-btn-group .v-btn {
      margin-left:10px;
      box-shadow: 0px 1px 0px rgba(0,0,0,0.1);
      background: white !important;
      padding: 20px 10px;
      text-transform: none;
      letter-spacing: 0.01em;
      color: #46545c;
      font-size: 12px;
      font-weight: 700;
      &.success {
        background: #70cd0d !important;
        color: white;
      }
      span {
        max-width: 175px;
      }
    }
  }
  .v-list--three-line .v-list-item, .v-list-item--three-line {
    min-height: 35px !important;
  }
  .v-list--rounded.v-list--three-line .v-list-item, .v-list--rounded.v-list--three-line .v-list-item:before, .v-list--rounded.v-list--three-line .v-list-item>.v-ripple__container {
      border-radius: 0px !important;
  }
  .v-list-item {
    text-align: left;
  }
  .v-list-item__title {
    font-size: 15px !important;
  }
  .v-list--nav .v-list-item:not(:last-child):not(:only-child), .v-list--rounded .v-list-item:not(:last-child):not(:only-child){
    margin-bottom: 0px !important;
  }
  .v-list-item__content{
    text-align: left !important;
  }
  .v-data-table td, .v-data-table th{
    padding: 0px !important;
  }
</style>



// WEBPACK FOOTER //
// src/views/dashboard/database/prestation/listing.vue